// import { useSelector } from 'react-redux'
import { useCallback, useMemo } from 'react'

import CampaignForm from './CampaignForm'

import AdGamCreateForm from './AdForm'
import LineItemForm from './LineItemForm'

import useContinuousForm from '../../../../hooks/formHooks/useContinuousForm'

export const CAMPAIGN_FORM = 'campaign_form'
export const LINE_ITEM_FORM = 'line_item_form'
export const AD_FORM = 'ad_form'

const UploadGamAdCreativeForm = ({ onSuccessSubmit }) => {
  // const campaign = useSelector(facebookRightUploadAdCampaignSelector)
  // const lineItem = useSelector(facebookRightUploadAdLineItemSelector)

  const { activatedForm, setActivatedForm } = useContinuousForm({
    initialForm: CAMPAIGN_FORM
  })

  // const onSuccessAdFormSubmit = useCallback(() => {
  //   onSuccessSubmit({
  //     [ROUTE_PARAMS.campaignId]: campaign.id,
  //     [ROUTE_PARAMS.lineItemId]: lineItem.id
  //   })
  // }, [campaign.id, lineItem.id, onSuccessSubmit])

  const formProgressItems = useMemo(
    () => [
      {
        label: 'Campaign',
        isActive: activatedForm === CAMPAIGN_FORM,
        isSuccess: activatedForm === LINE_ITEM_FORM || activatedForm === AD_FORM
      },
      {
        label: 'Line item',
        isActive: activatedForm === LINE_ITEM_FORM,
        isSuccess: activatedForm === AD_FORM
      },
      {
        label: 'Creative assets',
        isActive: activatedForm === AD_FORM,
        isSuccess: false
      }
    ],
    [activatedForm]
  )

  const getActivatedForm = useCallback(() => {
    switch (activatedForm) {
      case LINE_ITEM_FORM:
        return (
          <LineItemForm
            formProgressItems={formProgressItems}
            onSuccessSubmit={() => {
              setActivatedForm(AD_FORM)
            }}
          />
        )
      case AD_FORM:
        return <AdGamCreateForm onSuccessSubmit={onSuccessSubmit} />
      case CAMPAIGN_FORM:
      default:
        return (
          <CampaignForm
            formProgressItems={formProgressItems}
            onSuccessSubmit={() => {
              setActivatedForm(LINE_ITEM_FORM)
            }}
          />
        )
    }
  }, [activatedForm, formProgressItems, onSuccessSubmit, setActivatedForm])

  return getActivatedForm()
}

export default UploadGamAdCreativeForm
